'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var siteFooterComponent = exports.siteFooterComponent = {
    template: require('./site-footer.html'),
    controllerAs: 'vm',
    controller: ["config", "localizer", "$state", function controller(config, localizer, $state) {
        'ngInject';

        var vm = this;
        vm.env = config.env !== 'prod' ? config.env : '';
        vm.currentLanguage = localizer.getCurrentLanguage();
        vm.setLanguage = setLanguage;

        function setLanguage(language) {
            localizer.setLanguage(language);
            $state.go('.', { language: language });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/layout/site-footer.js
// module id = 941
// module chunks = 0